<script setup lang="ts">
import { computed } from 'vue';

interface Props {
  authorName: string;
  authorTitle: string;
  authorAvatarUrl?: string;
}

const props = defineProps<Props>();

const initialsName = computed(() => {
  if (!props.authorName) return '';
  const parts = props.authorName.split(' ').filter(Boolean);
  const initials = parts.length > 1 ? [parts[0], parts[parts.length - 1]] : parts;

  return initials.map((part) => part[0].toUpperCase()).join('');
});
</script>

<template>
  <div class="author-card">
    <img v-if="authorAvatarUrl" class="author-card__avatar" :src="authorAvatarUrl" :alt="authorName" />
    <div v-else class="author-card__avatar author-card__avatar--initials">
      {{ initialsName }}
    </div>
    <div class="author-card__info">
      <span class="author-card__name">{{ authorName }}</span>
      <span class="author-card__title">{{ authorTitle }}</span>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.author-card {
  display: flex;
  align-items: center;
  gap: 16px;

  &__avatar {
    width: 48px;
    height: 48px;
    border-radius: 50%;
    object-fit: contain;
    border: 1px solid var(--white-color);

    &--initials {
      display: flex;
      align-items: center;
      justify-content: center;
      font-weight: 700;
      font-size: 0.875rem;
      color: var(--secondary-text-color);
      background-color: var(--blue-color);
    }
  }

  &__info {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }

  &__name {
    font-weight: 700;
    font-size: 0.875rem;
    line-height: 1.3;
    color: var(--white-color);
  }

  &__title {
    font-weight: 400;
    font-size: 0.875rem;
    line-height: 1.3;
    color: rgba(255, 255, 255, 0.6);
  }
}
</style>
